import { Component, OnInit, ViewChildren, ElementRef } from '@angular/core';
import {
  StrAdmnPublishedProductFilterModel,
  StrAdmnPublishedProductUpdateModel,
  StrAdmnPublishedProductDeleteModel,
  StrAdmnWareHousePublishedProductDeleteModel
} from '../../models/store';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { StoreService } from '../../services/store.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { environment } from '@env/environment';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { AddProductPopupComponent } from '../add-product-popup/add-product-popup.component';
import { EncrDecrService } from '../../../../shared/services/encr-decr-service.service';
import { CryptoKeyValue } from '../../../../shared/constants';
import { Router } from '@angular/router';
import { DesignHuddleImageService } from '@app/shared/services/design-huddle/design-huddle-image.service';

@Component({
  selector: 'app-published-product',
  templateUrl: './published-product.component.html',
  styleUrls: ['./published-product.component.css']
})
export class PublishedProductComponent implements OnInit {
  storeList!: any[];
  StorePublishedProductList!: any[];
  ApplicationUserId!: any;
  storeadminStoreForm: FormGroup;
  filterModel!: StrAdmnPublishedProductFilterModel;
  PublishedProductUpdateModel!: StrAdmnPublishedProductUpdateModel;
  PublishedProductDeleteModel!: StrAdmnPublishedProductDeleteModel;
  WareHousePublishedProductDeleteModel!: StrAdmnWareHousePublishedProductDeleteModel;

  // For Infinite scroll of grid
  pageSize = 8; // No of items to load from server side i.e no of items to take
  initialItemsCount = 0; // No of items to skip
  throttle = 50;
  tscrollDistance = 1;
  // ---------------------------------
  noOfCustomizedSides !: any;    //added by rahul
  enableCustomizedProductId = 0;
  enableupdatebuttononId = 0;
  isvalidRetail = true;
  updateOrderAmt = 0;
  imgBaseURL = environment.imgBaseURL;
  imgCustomBaseURL =  environment.productCustomImageFolder;
  imgWareHouseBaseURL =  environment.warehouseProductCustomImageFolder;

  // To show hide 'No record div'
  isDisplay = 'none';
  isLoading = 'table-row';
  // ---------------------------
  @ViewChildren('brandCheckbox') private nameInputRef!: ElementRef;
  HasDiscount: boolean;
  constructor(
    private loader: LoaderService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private storeService: StoreService,
    private commonService: CommonService,
    private errorhandlerService: ErrorhandlerService,
    private http: HttpClient,
    public dialog: MatDialog,
    public EncrDecr: EncrDecrService,
    private router: Router,
    private designHuddleImageService: DesignHuddleImageService
  ) {
    this.storeadminStoreForm = this.formBuilder.group({
      StoreId: new FormControl(''),
      SkipNoOfRecord: 0,
      TakeNoRecord: 10
    });
  }

  ngOnInit() {
    this.fn_Initialize();
  }

  fn_setStoreValue(event: any) {
    this.isLoading = 'table-row';
    this.isDisplay = 'none';
    localStorage.setItem("storeId", event);

    this.storeadminStoreForm.patchValue({
      StoreId: event
    });
    this.filterModel.StoreId = this.storeadminStoreForm.controls[
      'StoreId'
    ].value;
    this.fn_GetPublishedProductList(false);
  }

  /** Function to get store list */
  fn_getStoreList() {
    this.loader.show();
    this.commonService
      .getStoreList('', 0, 0, false, this.ApplicationUserId, false)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.storeList = res.Data.ResponseData;
            this.storeadminStoreForm.patchValue({
              StoreId: this.storeList[0].StoreId
            });
            this.loader.hide();
            this.filterModel.StoreId = this.storeList[0].StoreId;
            this.fn_GetPublishedProductList(false);
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            this.isLoading = '';
            this.isDisplay = 'table-row';
            this.loader.hide();
          }
        },
        err => {
          this.loader.hide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        }
      );
  }
  fn_Initialize() {
    this.initialItemsCount = 0;
    this.storeList = [];
    this.StorePublishedProductList = [];
    this.ApplicationUserId = localStorage.getItem('userId');
    this.filterModel = {
      Skip: this.initialItemsCount,
      Take: 10,
      UserId: localStorage.getItem('userId'),
      StoreId: ''
    };
    this.PublishedProductUpdateModel = {
      CustomizedProductId: '',
      UserId: localStorage.getItem('userId'),
      StoreId: '',
      RetailPrice: ''
    };
    this.PublishedProductDeleteModel = {
      CustomizedProductId: '',
      UserId: localStorage.getItem('userId'),
      StoreId: ''
    };
    this.WareHousePublishedProductDeleteModel = {
      WareHouseProductId: 0,
      UserId: localStorage.getItem('userId'),
      StoreId: ''
    };
    this.fn_getStoreList();
  }

  /** Func to get published list */
  fn_GetPublishedProductList(status: boolean) {
    // Status FALSE means func is called on page load/from store dropdown change
    // than show application global loader
    // Status TRUE means func is called from scroll, than show lazy loader
    if (!status) {
      this.initialItemsCount = 0;
      this.StorePublishedProductList = [];
      this.loader.show();
    } else {
      this.loader.lazyLoaderShow();
    }
    this.filterModel.Skip = this.initialItemsCount;
    if (localStorage.getItem("storeId") != ""
      && localStorage.getItem("storeId") != null
      && localStorage.getItem("storeId") != "null"
      && localStorage.getItem("storeId") != undefined)
      this.filterModel.StoreId = localStorage.getItem("storeId");
    this.storeService
      .GetStoreAdminPublishedProductList(this.filterModel)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            //After getting basic detials again new hit is being sent for getting detail of prices erc
            this.fn_AddLazyLoadedItems(res.Data.ResponseData);
            this.loader.hide();
            this.loader.lazyLoaderHide();
            this.isLoading = '';
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            if (this.initialItemsCount <= 0) {
              this.notificationService.error(res.Message, 'Record(s)');
            }
            this.loader.hide();
            this.loader.lazyLoaderHide();
            this.isLoading = '';
          }
        },
        (err: any) => {
          this.loader.hide();
          this.loader.lazyLoaderHide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
          this.isLoading = '';
        }
      );
  }

  /** Function to add new lazy loaded items to original items list */
  fn_AddLazyLoadedItems(items: any) {
    if (items !== null && items.length !== 0) {
      for (let i = 0; i < items.length; i++) {
        //if not warehouseproduct
        if (items[i].IsWarehouseProduct == false) {

          if(items[i].IsImageCustom)
            items[i].ImageName = this.imgCustomBaseURL + items[i].ImageName;
          else
            items[i].ImageName = this.imgBaseURL + items[i].ImageName;

          this.storeService.getPriceDetails(items[i].ProductId, items[i].DesignId, items[i].StoreId)
            .subscribe((res: any) => {
              if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
                items[i].ProductId = this.EncrDecr.set(CryptoKeyValue.Key, items[i].ProductId.toString());
                items[i].DesignId = this.EncrDecr.set(CryptoKeyValue.Key, items[i].DesignId.toString());
                var discount = res.Data.ResponseData[0].Discount;
                this.HasDiscount = discount != null && discount > 0;
                this.noOfCustomizedSides = res.Data.ResponseData.length;
                //Since the price already including the only 1 print location in the Product Base cost, thus -1 Side from total print locations.
                // for customization type Embroidery
                if (res.Data.ResponseData[0].IsEmbroideryType) {

                   var cost = (res.Data.ResponseData[0].EmbroideryCost) * (this.noOfCustomizedSides - 1);
                  items[i].ProductDescription.UnitCostWithoutDiscount = items[i].ProductDescription.UnitCost + cost + items[i].FinshingPrice;
                  items[i].ProductDescription.SellingPrice = cost + items[i].ProductDescription.UnitCost + items[i].RetailPrice + items[i].FinshingPrice;
                  var costbeforeDiscount = items[i].ProductDescription.UnitCost + cost;
                  //Apply discount if has any
                  if (discount > 0 || discount != null) {
                    items[i].ProductDescription.Discount = (costbeforeDiscount * (discount / 100)); //Doscunt in $
                    items[i].ProductDescription.UnitCost = costbeforeDiscount - items[i].ProductDescription.Discount; //After discount price
                  }
                } else {
                  items[i].PrintingCost = res.Data.ResponseData[0].PrintingCost * (this.noOfCustomizedSides - 1);
                items[i].ProductDescription.UnitCostWithoutDiscount = items[i].ProductDescription.UnitCost + items[i].PrintingCost + items[i].FinshingPrice;
                items[i].ProductDescription.SellingPrice = items[i].PrintingCost + items[i].ProductDescription.UnitCost + items[i].RetailPrice + items[i].FinshingPrice;
                var costbeforeDiscount = items[i].ProductDescription.UnitCost + items[i].PrintingCost;
                //Apply discount if has any
                if (discount > 0 || discount != null) {
                  items[i].ProductDescription.Discount = (costbeforeDiscount * (discount / 100)); //Doscunt in $
                  items[i].ProductDescription.UnitCost = costbeforeDiscount - items[i].ProductDescription.Discount; //After discount price
                }
                }
                
                if (res.Data.ResponseData[0].SavedStyles.length > 0) {
                  let savedStyleIds = res.Data.ResponseData[0].SavedStyles.map(a => a.UniqueStyleId);

                  items[i].PricePerSizeStyle = res.Data.ResponseData[0].Styles.filter(function (item) {
                    return savedStyleIds.indexOf(item.UniqueStyleId) != -1;
                  });

                  //calcualte the price without discount
                  items[i].PricePerSizeStyle.forEach(function (style) {
                    style.Sizes.forEach(function (size) {
                      var costwithoutDiscount: any;
                      if (items[i].IsEmbroideryType) {
                        costwithoutDiscount = size.UnitPrice + (items[i].EmbroideryCost );
                        //Apply discount if has any
                        if (discount > 0 || discount != null) {
                          size.UnitPrice = costwithoutDiscount - (costwithoutDiscount * (discount / 100));
                        }
                        size.UnitPriceWithoutDiscount = size.UnitPriceWithoutDiscount + (items[i].EmbroideryCost) + items[i].FinshingPrice;
                      } else {
                        costwithoutDiscount = size.UnitPrice + items[i].PrintingCost;
                        //Apply discount if has any
                        if (discount > 0 || discount != null) {
                          size.UnitPrice = costwithoutDiscount - (costwithoutDiscount * (discount / 100));
                        }
                        size.UnitPriceWithoutDiscount = size.UnitPriceWithoutDiscount + items[i].PrintingCost + items[i].FinshingPrice;
                      }
                     
                    });
                  });
                }
              }
            });
        } else {
          items[i].ProductDescription.Discount = items[i].ProductDescription.Discount;//0 from backend, no discount on warehouse products
          items[i].ProductDescription.UnitCostWithoutDiscount = items[i].ProductDescription.UnitCost;
          items[i].ProductDescription.SellingPrice = items[i].RetailPrice;
          if (items[i].ImageName.indexOf('https://stores.inksoft.com') !== -1)
            items[i].ImageName =  items[i].ImageName;
          else
            items[i].ImageName = this.imgWareHouseBaseURL + items[i].ImageName;


          this.storeService.getWareHousePriceDetails(items[i].WareHouseProductId).subscribe((res: any) => {
            items[i].PricePerSizeStyle = res.Data.ResponseData[0].Styles;
          });
        };

        //This should be 0 initially, we want it to get updated on basis of the product customize sides. Code above to this runs at Background  
        items[i].PrintingCost = 0;
        this.initialItemsCount = this.StorePublishedProductList.push(items[i]);
      }
    }
    this.isDisplay = this.initialItemsCount > 0 ? 'none' : 'table-row';
  }
  /** Function to display product color(s) in color selector */
  displayColor(obj: any) {
    return {
      'background': obj
    };
  }
  fneditrow(event: any, customizedProductId: any) {
    this.enableCustomizedProductId = customizedProductId;
    this.isvalidRetail = false;
  }

  showAddProductWindow() {
    this.router.navigate(['/store/upload-design']);
  }

  // -------------------- used for update the published product retail price per store -----------------/
  fnupdaterow(customizedProductId: any, amount: HTMLInputElement, DesignID: any, RetailPrice: any, SellingPrice: any) {

    //since the code is f**ked up to get new SellingPrice here's away
    const newPrice = Number(SellingPrice) - Number(RetailPrice) + Number(amount.value);

    this.storeService.getStoreById(this.filterModel.StoreId).subscribe((res: any) => {
      if (res.Data.ResponseData.apikey) {
        this.http.post<any>(environment.baseUrlShopifyApp + "/api/product/price", {
          "price": newPrice,
          "productid": DesignID
        }, {
          headers: {
            "x-api-key": res.Data.ResponseData.apikey
          }
        }).subscribe((data) => {
      
        });
      }
    });
    this.loader.show();
    this.PublishedProductUpdateModel.CustomizedProductId = customizedProductId;
    this.PublishedProductUpdateModel.UserId = this.ApplicationUserId;
    this.PublishedProductUpdateModel.StoreId = this.storeadminStoreForm.controls[
      'StoreId'
    ].value;
    this.PublishedProductUpdateModel.RetailPrice = amount.value;

    this.storeService
      .UpdateStoreAdminPublishedProductList(this.PublishedProductUpdateModel)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.notificationService.success(res.Message, 'Published Product');
            this.fn_GetPublishedProductList(false);
            // --- to disable the retail price and update button----------//
            this.enableupdatebuttononId = 0;
            //this.StorePublishedProductList.ProductDescription.SellingPrice + this.PublishedProductUpdateModel.RetailPrice
            this.enableCustomizedProductId = 0;
            this.isvalidRetail = false;
            // --------------- till here -----------//
            this.loader.hide();
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            if (this.initialItemsCount <= 0) {
              this.notificationService.error(res.Message, 'Published Product');
            }
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        }
      );
  }

  //This is not being used as the price will be updated per size and color wise thus we will manage this from warehouse listing product pages
  fnupdaterowWarehouse(wareHouseProductId: any, profit: HTMLInputElement) {
    this.storeService.updateRetailPriceForWareHouseProduct(wareHouseProductId, Number(profit.value)).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notificationService.success('Profit Updated Success', 'Success');
        this.fn_GetPublishedProductList(false);
        // --- to disable the retail price and update button----------//
        this.enableupdatebuttononId = 0;
        this.enableCustomizedProductId = 0;
        this.isvalidRetail = false;
        // --------------- till here -----------//
        this.loader.hide();
      }
    })
  }

  // -------------------- used for delete the published product from store -----------------/
  fndeleterow(customizedProductId: any, designId: any) {
    this.loader.show();
    this.PublishedProductDeleteModel.CustomizedProductId = customizedProductId;
    this.PublishedProductDeleteModel.UserId = this.ApplicationUserId;
    this.PublishedProductDeleteModel.StoreId = this.storeadminStoreForm.controls[
      'StoreId'
    ].value;
    this.storeService.getStoreById(this.PublishedProductDeleteModel.StoreId).subscribe((res: any) => {
      if (res.Data.ResponseData.apikey) {
        this.http.post<any>(environment.baseUrlShopifyApp + '/api/product/delete', {
          'productid': designId
        }, {
          headers: {
            'x-api-key': res.Data.ResponseData.apikey
          }
        }).subscribe((data) => {
     
        });
      }
    });
    this.storeService
      .DeleteStoreAdminPublishedProductList(this.PublishedProductDeleteModel)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.notificationService.success(res.Message, 'Published Product');
            this.fn_GetPublishedProductList(false);
            this.loader.hide();
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            if (this.initialItemsCount <= 0) {
              this.notificationService.error(res.Message, 'Published Product');
            }
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        }
      );
  }

  // -------------------- used for delete the published product from store -----------------/
  fndeleterowWarehouseProduct(warehouseProductId: any) {
    this.loader.show();
    this.WareHousePublishedProductDeleteModel.WareHouseProductId = warehouseProductId;
    this.WareHousePublishedProductDeleteModel.UserId = this.ApplicationUserId;
    this.WareHousePublishedProductDeleteModel.StoreId = this.storeadminStoreForm.controls[
      'StoreId'
    ].value;

    this.storeService
      .DeleteStoreAdminWareHouseProduct(this.WareHousePublishedProductDeleteModel)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.notificationService.success(res.Message, 'Published Product');
            this.fn_GetPublishedProductList(false);
            this.loader.hide();
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            if (this.initialItemsCount <= 0) {
              this.notificationService.error(res.Message, 'Published Product');
            }
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          // this.notificationService.error('An error occured', 'Error');
          this.errorhandlerService.handleError(err);
        }
      );
  }

  // -------------------- used for test the pattern and show hide the update button -----------------/
  fn_testPattern(amount: HTMLInputElement, customizedProductId: any) {
    const trigger = amount.value;
    const regexp3 = /^\d{0,6}(\.\d{1,2})?$/;
    //const regexp3=/^[0-6-+()]*$/;
    if (trigger !== '') {
      const test = regexp3.test(trigger);
      if (test) {
        this.enableupdatebuttononId = customizedProductId;
        this.isvalidRetail = true;
      } else {
        this.enableupdatebuttononId = 0;
        this.isvalidRetail = true;
      }
    } else {
      this.enableupdatebuttononId = 0;
      this.isvalidRetail = false;
    }
  }

  getProductImage(product: any): string {
    return this.designHuddleImageService.getProductThumbnailUrl(product);
  }

}
